import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useWarehouse } from '../../Providers/WarehouseProvider';
import SelectBox from 'devextreme-react/select-box';
import useWarehouseOperations from '../../Hooks/useWarehouseOperations';
import { useAuth } from '../../Providers/AuthProvider';

const MobileWarehouseSelectorModal = ({ show, setShow }) => {
    const { authState } = useAuth()
    const { findSelectedWarehouseName } = useWarehouseOperations()
    const { warehouses, handleChangeWarehouse } = useWarehouse()
    const [selectedWarehouse, setSelectedWarehouse] = useState(null)

    useEffect(() => {
        const selectedWarehouseName = findSelectedWarehouseName(authState.whId)
        if (selectedWarehouseName && selectedWarehouseName.trim() !== '') {
            setSelectedWarehouse(warehouses.find(w => w.name === selectedWarehouseName))
        }
    }, [])

    const handleChangeWarehouseFunc = (e) => {
        e.stopPropagation()
        if (selectedWarehouse) {
            handleChangeWarehouse(selectedWarehouse)
        }
        setShow(false)
    }

    return (
        <>
            <Modal size='lg' show={show} onHide={() => setShow(false)} centered style={{ zIndex: 3000 }} enforceFocus={false}>
                <Modal.Header closeButton={true}>
                    <Modal.Title>{'Zmień wybrany magazyn'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <SelectBox
                        items={warehouses}
                        value={selectedWarehouse}
                        onValueChanged={(e) => setSelectedWarehouse(e.value)}
                        placeholder="Wybierz magazyn"
                        noDataText="Brak danych"
                        showClearButton={false}
                        displayExpr={'name'}
                        dropDownOptions={{ container: '.modal-content' }}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <div className='d-flex flex-column'>
                        <button className='btn-app-primary me-3' onClick={(e) => handleChangeWarehouseFunc(e)}>Wybierz</button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default MobileWarehouseSelectorModal